<div #filePathRef class="mc-self-truncating-path-container" [style.visibility]="isVisiblePathStyle" tabindex="-1">
  <ng-template ngFor let-item [ngForOf]="pathItems" [ngForTrackBy]="trackByFn">
    <span *ngIf="item" matTooltipClass="mc-tooltip-multiline" [matTooltip]="filePath" [matTooltipDisabled]="!showTooltip"> {{currentFilePath}} </span>
    <span *ngIf="!item" mcLifeCycle (afterViewInit)="onDetectorAfterViewInit()"></span>
  </ng-template>
</div>